module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('search', {
    ref: "search",
    attrs: {
      "position": "absolute",
      "auto-scroll-to-top": ""
    },
    on: {
      "on-focus": _vm.onFocus,
      "on-submit": _vm.getUserInfo,
      "on-cancel": _vm.onCancel
    },
    model: {
      value: (_vm.memberId),
      callback: function($$v) {
        _vm.memberId = $$v
      },
      expression: "memberId"
    }
  }, [_c('x-button', {
    nativeOn: {
      "click": function($event) {
        _vm.getUserInfo($event)
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageLoaded),
      expression: "pageLoaded"
    }],
    style: ({
      marginTop: _vm.mtpx + 'px'
    })
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": _vm.member.info.headimgurl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "个人信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": "用户ID",
      "value": _vm.member.info.id
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "昵称",
      "value": _vm.member.info.nick_name
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "会员等级",
      "value": _vm.userLevel
    }
  }), _vm._v(" "), (_vm.member.info.mobile > 0) ? _c('cell', {
    attrs: {
      "title": "手机号码"
    }
  }, [_c('a', {
    attrs: {
      "href": ("tel:" + (_vm.member.info.mobile))
    }
  }, [_vm._v(_vm._s(_vm.member.info.mobile))])]) : _vm._e(), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "他的推荐人",
      "value": _vm.member.info.ref_nick_name
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "关注日期",
      "value": _vm.member.info.create_time
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "代理信息"
    }
  }, [_c('cell', {
    attrs: {
      "title": "代理区域",
      "value": "北京市"
    }
  }), _vm._v(" "), _vm._l((_vm.pbList), function(item) {
    return _c('cell', {
      key: item.product_cate_id,
      attrs: {
        "title": _vm._f("getTitle")(item.promise_balance),
        "value": ("¥ " + (item.promise_balance) + " 元"),
        "is-link": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.renewPb(item)
        }
      }
    })
  })], 2), _vm._v(" "), (_vm.member.order > 0) ? _c('group', {
    attrs: {
      "title": "他的订单"
    }
  }, [_c('cell', {
    attrs: {
      "title": "查看他的订单",
      "value": _vm.member.order + ' 单',
      "link": '/uc/member/order/' + _vm.member.info.id,
      "is-link": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('group', [_c('x-button', {
    attrs: {
      "link": "BACK"
    }
  }, [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  }, [_c('group', {
    attrs: {
      "title": "填写金额"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "输入金额",
      "is-type": "number",
      "min": 1,
      "placeholder": "金额必须是正数",
      "required": ""
    },
    model: {
      value: (_vm.renew.pbAmount),
      callback: function($$v) {
        _vm.$set(_vm.renew, "pbAmount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "renew.pbAmount"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "title": "选择操作"
    }
  }, [_c('radio', {
    attrs: {
      "options": [{
        value: '增加',
        key: '+'
      }, {
        value: '减少',
        key: '-'
      }]
    },
    model: {
      value: (_vm.renew.pbOption),
      callback: function($$v) {
        _vm.$set(_vm.renew, "pbOption", $$v)
      },
      expression: "renew.pbOption"
    }
  })], 1), _vm._v(" "), _c('group', [_c('x-switch', {
    attrs: {
      "title": "微信通知用户",
      "value-map": ['off', 'on']
    },
    model: {
      value: (_vm.renew.noticeUser),
      callback: function($$v) {
        _vm.$set(_vm.renew, "noticeUser", $$v)
      },
      expression: "renew.noticeUser"
    }
  })], 1), _vm._v(" "), _c('group', [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.changePromiseBalance($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41794211"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/AdminMemberInfo.vue
// module id = 675
// module chunks = 0